//@flow
import React from 'react';

type Props = {
  qty:number,
  inStock:boolean,
  isAllowed:boolean,
  comingSoon:boolean,
  preSale:boolean,
  onClick:() => void,
  inCheckout?:boolean,
};

export default function AddCartButton(props:Props) {
  let buttonText = props.qty ? props.qty + " in cart" : "Add to cart";
  const className = _getClassName(props);

  if (props.preSale && props.inStock && !props.qty) {
    buttonText = "Pre-order now";
  } else if (props.comingSoon && !props.inStock && !props.qty) {
    buttonText = "Coming soon";
  } else if (!props.inStock && props.isAllowed) {
    buttonText = "Sold out";
  }

  if (buttonText === 'Add to cart' && props.inCheckout) buttonText += ' & checkout';

  return (
    <button onClick={props.onClick} className={className} title="Add to Cart">
      {buttonText}
    </button>
  );
}

AddCartButton.defaultProps = {
  isAllowed: true,
};

function _getClassName(props:Props) {
  let className = props.qty ? "has-items-detail" : "no-items-detail";

  if (!props.isAllowed) {
    className = "not-allowed";
  } else if (!props.inStock) {
    className = "oos-items-detail";
  } else if (props.inStock && props.preSale) {
    className = "presale-items-detail";
  }

  return `detail-add ${className}`;
}
